import { Box, Typography } from '@mui/material'

import * as S from './ChargeFineAndInterest.styles'
type ChargeFineAndInterestProps = {
  interestFine: number | string
  interestFee: number | string
  interestPolicy?: string
  removeMargin?: boolean
}

export default function ChargeFineAndInterest({
  interestFee,
  interestFine,
  interestPolicy,
  removeMargin
}: ChargeFineAndInterestProps) {
  if (interestPolicy === 'no_interest') {
    return (
      <Box
        display="flex"
        gap={1.25}
        alignItems="end"
        margin={removeMargin ? '' : '10px 0px 10px 0px'}
      >
        <Typography variant="smLight" color="#777777">
          Juros
        </Typography>
        <S.Separator sx={{ marginTop: '4px' }} />
        <Typography variant="smBold">Não</Typography>
      </Box>
    )
  }

  const multa = Number(interestFine).toFixed(2).replace('.', ',')

  const juros = Number(interestFee).toFixed(2).replace('.', ',')

  return (
    <>
      <Box
        display="flex"
        gap={1.25}
        alignItems="end"
        margin={removeMargin ? '' : '10px 0px 10px 0px'}
      >
        <Typography variant="smLight" color="#777777">
          Multa
        </Typography>
        <S.Separator sx={{ marginTop: '4px' }} />
        <Typography variant="smBold" display="flex" alignItems="center">
          {multa !== '0,00' ? `${multa}%` : 'Não'}
        </Typography>
      </Box>
      <Box
        display="flex"
        gap={1.25}
        alignItems="end"
        margin={removeMargin ? '' : '10px 0px 10px 0px'}
      >
        <Typography variant="smLight" color="#777777">
          Juros
        </Typography>
        <S.Separator sx={{ marginTop: '4px' }} />
        <Typography variant="smBold" display="flex" alignItems="center">
          {juros !== '0,00' ? `${juros}% ao mês` : 'Não'}
        </Typography>
      </Box>
    </>
  )
}
